// Centralized color palette for the application.
// Update or extend this file whenever you need new theme colours so
// the entire code-base stays in sync.
//
// Usage example:
// import COLORS from "../Utils/colors";
// <Button sx={{ bgcolor: COLORS.primary }} />

const COLORS = {
  // Primary brand / accent colour
  primary: '#FF6B35', // vibrant burnt-orange used for CTAs & highlights

  // Core palette taken from the latest design spec
  burntOrange: '#F57C00',
  tealBlue: '#00838F',
  offWhite: '#FAFAFA',

  // Neutral & utility colours
  softGray: '#EEEEEE',
  charcoal: '#263238',
  sandBeige: '#FFE0B2',

  // Tertiary / status colours
  skyBlue: '#AFC3F7',
  leafGreen: '#81C784',
  sunriseCoral: '#FF7043',

  // Misc frequently-used greys
  grey: '#E0E0E0',
  lightBrown: '#ECE0DA99',
} as const;

export default COLORS;
